import ModelReviewInterface from "../../../interfaces/model/ModelReviewInterface";
import Stars from "./Stars";
import moment from "moment";

export default function Review({review}: { review: ModelReviewInterface }) {
    const getDate = (date: string) => {
        return moment(date).format('DD.MM.YYYY')
    }

    return (<div className="product__feedback-block">
            <div className="img">
                <img src="/img/svg/feeedback-img-1.svg" alt=""/>
            </div>
            <div className="info">
                <div className="top">
                    <div className="top-block">
                        <h6>{review.customer_name}</h6>
                        <p>{getDate(review.create_date)}</p>
                    </div>
                    {review.partner && review.partner !== 'baon' && <p className="desk">{review.partner}</p>}
                    <a className="mob btn-col ico ico-arrow-bot-b" href=""/>
                </div>
                <div className="meta">
                    {review.estimate && <Stars reviewAverageEstimate={review.estimate}/>}
                    {/*<p className="desk">Цвет: Black</p>*/}
                    {/*<p className="desk">Размер: M, Соответствует размеру</p>*/}
                </div>
                <div className="mob">
                    <div className="bot">
                        {/*<p>Цвет: Black</p>*/}
                        {/*<p>Размер: M, Соответствует размеру</p>*/}
                    </div>
                </div>
                <div className="collapse-mob">
                    <div className="body">
                        <p>{review.review}</p>
                        {review.moderator_note && <>
                            <hr/>
                            <span className={'text-muted'}>{review.moderator_note}</span></>}
                    </div>
                    {/*<div className="imgs">*/}
                    {/*    <a className="img" href="" data-bs-toggle="modal" data-bs-target="#modal-prod-slider"><img*/}
                    {/*        src="/img/temp/product-model-1.jpg" alt=""/></a>*/}
                    {/*    <a className="img" href=""><i className="ico ico-play ico-color"></i><img*/}
                    {/*        src="/img/temp/product-model-2.jpg" alt=""/></a>*/}
                    {/*    <a className="img" href="" data-bs-toggle="modal" data-bs-target="#modal-prod-slider"><img*/}
                    {/*        src="/img/temp/card.jpg" alt=""/></a>*/}
                    {/*</div>*/}
                </div>
            </div>
        </div>
    )



}